import React from "react";
import { electricPurple500 } from "StylesConstants";
import { Container } from "./TitleCardCustom.styles";
import {
  formatCurrency,
  hasCityValue,
  normalizeText,
  propertyItems,
} from "./TitleCardCustom.utils";

const TitleCardCustom = ({ ciudad, ...props }) => {
  if (!hasCityValue(ciudad)) {
    return null;
  }

  const city = normalizeText(ciudad);
  const upz = normalizeText(props.upz);
  const location = [city, upz].filter(Boolean).join(" ");

  return (
    <Container $iconColor={props.iconColor || electricPurple500}>
      {props.title && <h1 className="main-title">{props.title}</h1>}

      {!!props.price && (
        <div className="price-wrapper">
          <p className="title-price">PRECIO DE VENTA*</p>
          <p className="price">{formatCurrency(props.price, props.TranslateCurrencies)}</p>
        </div>
      )}

      <p className="ubication">{location}</p>

      <div className="intro">
        {propertyItems(props)
          .filter((item) => item.isVisible)
          .map((item) => (
            <div className="item-prop" key={`${item.label}-${item.value}`}>
              {item.icon}
              <span className="titulo">
                {item.value}
                {item.isArea ? item.label : ` ${item.label}`}
              </span>
            </div>
          ))}
      </div>
    </Container>
  );
};

export default TitleCardCustom;
